import { makeStyles } from '@mui/styles';
import CircularProgress from 'apollo-react/components/CircularProgress';
import React from 'react';

const useStyles = makeStyles({
  root: {
    '& > div': {
      display: 'flex',
    },
  },
});

const Loader = ({ size = 28 }) => {
  const classes = useStyles();

  return (
    <CircularProgress
      className={classes.root}
      color="inherit"
      variant="indeterminate"
      size={size}
    />
  );
};

export default Loader;
